exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-empreendimentos-js": () => import("./../../../src/pages/empreendimentos.js" /* webpackChunkName: "component---src-pages-empreendimentos-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projeto-json-nome-js": () => import("./../../../src/pages/{projetoJson.nome}.js" /* webpackChunkName: "component---src-pages-projeto-json-nome-js" */)
}

